import {apiClient} from 'core/apiClient';
import {AuditExportFormat} from 'types/audit-log';
import {BlockingAuditEntry, BlockingAuditPage, BlockingAuditParams} from 'types/blocking-audit';

const URL = '/service/blocking/audit-log';

export async function fetchBlockingAuditLog(params: BlockingAuditParams) {
    return (await apiClient.get<BlockingAuditPage>(URL, {params})).data;
}

export async function fetchBlockingAuditEvent(id: string) {
    return (await apiClient.get<BlockingAuditEntry>(`${URL}/${id}`)).data;
}

export async function exportBlockingAuditEvent(id: string) {
    return (await apiClient.get<Blob>(`${URL}/${id}/export`, {responseType: 'blob'})).data;
}

export async function exportBlockingAuditLog(
    params: BlockingAuditParams & {format: AuditExportFormat; from: string; to: string},
) {
    return {
        data: (await apiClient.get<Blob>(`${URL}/export`, {params, responseType: 'blob'})).data,
    };
}
